import React from 'react';
import { getChildrenText } from '../utils/getChildrenText';
var AkStatusLozenge = /*#__PURE__*/React.lazy(function () {
  return import( /* webpackChunkName: '@atlaskit-internal_.lozenge' */
  '@atlaskit/lozenge');
});
export var StatusLozenge = function StatusLozenge(_ref) {
  var _ref$forgeDoc = _ref.forgeDoc,
    props = _ref$forgeDoc.props,
    children = _ref$forgeDoc.children;
  var _ref2 = props,
    appearance = _ref2.appearance;
  return /*#__PURE__*/React.createElement(AkStatusLozenge, {
    appearance: appearance
  }, getChildrenText(children));
};